export class PrchWorkflow {
    id?: string;
    area!: WorkFlowArea;
    name!: string;
    conditions: WorkFlowCondition[] = [];
    action!: WorkFlowAction;
    approvers: string[] = [];
}

export enum WorkFlowArea {
    PurchaseOrder = 0
}

export class WorkFlowCondition {
    type!: WorkFlowConditionType;
    amount!: number;
    operator!: ComparisonOperator;
    values: string[] = [];
}

export enum WorkFlowConditionType {
    OrderTotal = 0,
    Location = 1,
    CreatedBy = 2,
    Supplier = 3
}

export enum ComparisonOperator {
    LessThanOrEqual = 0,
    GreaterThanOrEqual = 1,
    LessThan = 2,
    GreaterThan = 3,
    IsAnyOf = 4,
    IsNotAnyOf = 5
}

export enum WorkFlowAction {
    CannotProceedWithoutApproval = 0,
    CreateAndSubmitInvoiceAndReceive = 1
}

export const NUMBER_OPERATORS = [
    ComparisonOperator.LessThanOrEqual,
    ComparisonOperator.GreaterThanOrEqual,
    ComparisonOperator.LessThan,
    ComparisonOperator.GreaterThan
];

export const LIST_OPERATORS = [ComparisonOperator.IsAnyOf, ComparisonOperator.IsNotAnyOf];

export function isListCondition(type: WorkFlowConditionType): boolean {
    return type === WorkFlowConditionType.Location
        || type === WorkFlowConditionType.CreatedBy
        || type === WorkFlowConditionType.Supplier;
}

export function operatorsFor(type: WorkFlowConditionType): ComparisonOperator[] {
    return isListCondition(type) ? LIST_OPERATORS : NUMBER_OPERATORS;
}